import { useMemo } from "react";
import type { RescheduleKindCounts } from "@myapp/contract";
import { useRescheduleInfiniteQuery } from "../../../../entities/reschedule";
import { useDebounce } from "../../../../shared/hooks/useDebounce";
import {
  mapFiltersFormToApi,
  RescheduleFiltersForm,
} from "./rescheduleFilters.types";
import {
  toRescheduleFiltersForm,
  useRescheduleFiltersParams,
} from "./useRescheduleFiltersParams";

const PAGE_LIMIT = 20;

export function useRescheduleFilters() {
  const [params, setParams] = useRescheduleFiltersParams();

  const filters = useMemo<RescheduleFiltersForm>(
    () => toRescheduleFiltersForm(params),
    [params],
  );

  const debouncedFilters = useDebounce(filters, 400);

  const apiFilters = useMemo(
    () => mapFiltersFormToApi(debouncedFilters, PAGE_LIMIT),
    [debouncedFilters],
  );

  const query = useRescheduleInfiniteQuery(apiFilters);

  // `meta` is typed as the plain pagination envelope; the endpoint adds `counts` to it.
  const counts = (query.data?.meta as { counts?: RescheduleKindCounts } | undefined)?.counts;

  return {
    filters,
    counts,
    setFilters: setParams,
    ...query,
  };
}
